// extracted by mini-css-extract-plugin
module.exports = {"paginglayer":"Paging_paginglayer__Uai8P","active":"Paging_active__2CYqa","info":"Paging_info__35I49","goto":"Paging_goto__1RorZ"};